import Pagination from '~/themes/base/components/molecule/Pagination'

export default {
  extends: Pagination,
}
